import Control from "../../Control";
import NP from "../../NP";
let S = require('string');

export default class ListGroupHeader extends Control {

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._isBind = true;
		let cnt = this._Content || NP.RM.getString(this._RK) || '';
		this.np_render(`<h3 class="app-list-group__subheader selectable">${S(cnt).escapeHTML().s}</h3>`);
	}

	setContent(value: string)
	{
		this._setContentToNode(value, this._root, 'Content');
	}
};